var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOrders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 1H6c-1.442 0-2.424.002-3.159.1-.706.096-1.033.263-1.255.486-.223.222-.39.55-.485 1.255C1.002 3.576 1 4.558 1 6v5c0 1.443.002 2.424.1 3.159.096.706.263 1.033.486 1.255.222.223.55.39 1.255.485C3.576 15.998 4.558 16 6 16h12c1.442 0 2.424-.002 3.159-.1.706-.096 1.033-.263 1.255-.486.223-.222.39-.55.485-1.255.099-.735.101-1.716.101-3.159V6c0-1.442-.002-2.424-.1-3.159-.096-.706-.263-1.033-.486-1.255-.222-.223-.55-.39-1.255-.485C20.424 1.002 19.443 1 18 1zM.879.879C0 1.757 0 3.172 0 6v5c0 2.828 0 4.243.879 5.121C1.757 17 3.172 17 6 17h12c2.828 0 4.243 0 5.121-.879C24 15.243 24 13.828 24 11V6c0-2.828 0-4.243-.879-5.121C22.243 0 20.828 0 18 0H6C3.172 0 1.757 0 .879.879z",
    fill: "#646D7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.82 17l-.6 3h3.56l-.6-3h-2.36zM14 16h-4l-1 5h6l-1-5z",
    fill: "#646D7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4 21H2.6a.6.6 0 00-.6.6A1.4 1.4 0 003.4 23h17.2a1.4 1.4 0 001.4-1.4.6.6 0 00-.6-.6zM2.6 20A1.6 1.6 0 001 21.6 2.4 2.4 0 003.4 24h17.2a2.4 2.4 0 002.4-2.4 1.6 1.6 0 00-1.6-1.6H2.6zM8 7a1 1 0 100-2 1 1 0 000 2zm0 1a2 2 0 100-4 2 2 0 000 4zm0 4a1 1 0 100-2 1 1 0 000 2zm0 1a2 2 0 100-4 2 2 0 000 4zm3.5-7a.5.5 0 01.5-.5h6a.5.5 0 010 1h-6a.5.5 0 01-.5-.5zm0 5a.5.5 0 01.5-.5h6a.5.5 0 010 1h-6a.5.5 0 01-.5-.5z",
    fill: "#646D7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrders);
export default __webpack_public_path__ + "static/media/ic-orders.a89ea660f65fcb9699ec3653c6dc7abf.svg";
export { ForwardRef as ReactComponent };